// extracted by mini-css-extract-plugin
export default {"label":"booking_expenses_label__qbKHF","notes":"booking_expenses_notes__k4HlR"};